import React, { useState, useEffect, useRef } from "react";
import { trackEvent } from "./../../utils/analytics";
import { useLocation, Navigate } from "react-router-dom";
import { getDocumentApi } from "../../apis/apis";

const Document: React.FC = () => {
  const [loading, setLoading] = useState(true);
  const iframe = useRef<any>(null);
  const locationState = useLocation().state as { link?: string; tenantAccountId?: string } | null;
  const link = locationState?.link;
  const tenantAccountId = locationState?.tenantAccountId;

  useEffect(() => {
    if (!link || !tenantAccountId) return;
    trackEvent({
      action: "View Document",
      value: link,
    });
    (async () => {
      try {
        const objectUrl = await getDocumentApi(link, tenantAccountId);
        if (iframe.current) iframe.current.src = objectUrl;
      } finally {
        setLoading(false);
      }
    })();
  }, [link, tenantAccountId]);

  if (!link || !tenantAccountId) {
    return <Navigate to="/documents" replace />;
  }

  return (
    <>
      {loading && <div style={{ padding: 30 }}>Loading...</div>}
      <iframe
        ref={iframe}
        title="Document"
        style={{ width: "100%", height: "100vh" }}
        frameBorder="0"
      ></iframe>
    </>
  );
};

export default Document;
